// Label dimensions and styling
export const labelConfig = {
  padding: 10,
  widePadding: 12,
  verticalPadding: 6,
};

// SVG layout proportions (relative to container dimensions)
export const layoutConfig = {
  svgHeightRatio: 0.25,
  columns: {
    leftX: 0.2,
    centerX: 0.5,
    rightX: 0.8,
  },
  rows: {
    labelY: 0.25,
    narrowLabelY: 0.3,
    numberY: 0.58,
    lineY: 0.7,
  },
};

// Reliable reporter icon and label positioning
export const reliableIconConfig = {
  width: 24,
  height: 24,
  offsetX: -60,
  offsetY: -40,
  labelOffsetX: -30,
  labelOffsetY: -30,
  labelLineHeight: "1.2em",
};

// Arrow polygon dimensions
export const arrowConfig = {
  horizontalSpread: 10,
  verticalOffset: 20,
};

// Animation configurations
export const animationConfig = {
  duration: 800,
  moveAmount: 20,
  lineOffsetAmount: 6,
  spring: {
    tension: 70,
    friction: 20,
  },
  cssTransition: "0.8s ease-in-out",
};

// Number values for animations
export const numberConfig = {
  defaultCenter: 851,
  weightedCenter: 750,
};

// Header and spacing
export const spacingConfig = {
  headerPaddingFactor: 0.5, // column1X * 0.5
  descriptionHeight: "15vh",
};

// Colors
export const colorConfig = {
  textDark: "rgb(77,77,77)",
  textMedium: "#707070",
  textDarkest: "#474747",
  lineStroke: "#A1A1A1",
  numberValue: "#D669BF",
  labelColors: {
    "Country A": "#69d7a7",
    "Country B": "#5e8bce",
    Average: "#707070",
    "Estimated Trade Value": "#474747",
  },
};
